import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=a99013a0&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"
import style0 from "./IconTitle.vue?vue&type=style&index=0&id=a99013a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99013a0",
  null
  
)

export default component.exports